import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { createAlert } from "../scripts/createAlert"

// Drag-and-drop reorder for Record Book list blocks on the current tab.
// Same SortableJS + PATCH pattern as player_notes_controller.js.
export default class extends Controller {
  static targets = ["record", "recordsContainer"]
  static values = {
    team: Number,
    recordBookTab: String
  }

  connect() {
    if (!this.hasRecordsContainerTarget) {
      return
    }

    Sortable.create(this.recordsContainerTarget, {
      draggable: ".record-book-record-sortable",
      dataIdAttr: "data-sortable-id",
      handle: ".sortable-handle",
      onUpdate: () => {
        const sortableIds = Array.from(this.recordTargets).map((element) => element.dataset.sortableId)
        const headers = {
          "Content-Type": "application/json",
          Accept: "application/json"
        }

        const csrfToken = document.querySelector('meta[name="csrf-token"]')
        if (csrfToken) {
          headers["X-CSRF-Token"] = csrfToken.getAttribute("content")
        }

        const tabQuery = encodeURIComponent(this.recordBookTabValue || "individual_game")
        fetch(`/entity/teams/${this.teamValue}/record_books/reorder?record_book_tab=${tabQuery}`, {
          method: "PATCH",
          headers,
          body: JSON.stringify({ ordered_record_ids: sortableIds })
        }).then(() => {
          createAlert("success", "Record list order updated")
        })
      }
    })
  }
}
